import vue from 'Vue';
export default new vue;


// WEBPACK FOOTER //
// ./src/common/Bus.js